import React, { useState } from 'react';
import styled from 'styled-components';
import { useSpring, animated } from '@react-spring/web';
import cx from 'classnames';
import useMeasure from 'react-use-measure';
const Panel = styled.div ``;
const PanelHeader = styled.div `
  background-color: var(--bg-color-1);
  color: var(--text-color-2);
  padding: 6px 24px;
`;
const PanelContent = styled(animated.div) `
  overflow-y: hidden;
`;
export const CollapsePanel = (props) => {
    const [open, setOpen] = useState(true);
    const [ref, { height }] = useMeasure();
    const styles = useSpring({
        height: open ? height : 0,
    });
    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    return (React.createElement(Panel, { className: "collapse-panel" },
        React.createElement(PanelHeader, { onClick: handleClick }, "header"),
        React.createElement(PanelContent, { style: styles },
            React.createElement("div", { ref: ref }, props.children))));
};
export const Collapse = (props) => {
    return React.createElement("div", { className: cx('collapse', props.className) }, props.children);
};
